import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-bone">
        <div className="animate-pulse font-serif text-2xl tracking-tighter text-obsidian">Loading…</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;

  return children;
};
